// Les numéros sont saisis au format national français (« 06 79 33 33 64 »).
// Un lien tel: avec ce seul format ne compose pas correctement depuis
// l'étranger ni sur certaines lignes VOIP, qui exigent l'indicatif
// international : on convertit donc un « 0 » initial en « +33 ». Hypothèse
// volontairement bornée au cas français (institut et clientèle très
// majoritairement français) — ce n'est pas un traitement téléphonique
// général, et un numéro déjà international (qui commence par « + ») est
// laissé tel quel.
//
// Partagé entre le pied de page et le message d'indisponibilité du module de
// réservation (cf. PlanityWidgetStatus.jsx) : un seul endroit qui sait
// comment fabriquer un lien tel: à partir d'un numéro français.
export function frenchNumberToTelHref(phone) {
  const digits = phone.replace(/\s/g, '')
  if (digits.startsWith('+')) return `tel:${digits}`
  return `tel:${digits.replace(/^0/, '+33')}`
}
